import { useContext } from 'react';
import { createContext } from 'react';

export interface FlexLayoutContextProps {
	parent: string;
	children: any;
}
export const FlexLayoutContext = createContext<FlexLayoutContextProps>({} as FlexLayoutContextProps);

FlexLayoutContext.displayName = 'FlexRow';

export function FlexLayoutContextProvider(props: FlexLayoutContextProps) {
	return <FlexLayoutContext.Provider value={props}>{props.children}</FlexLayoutContext.Provider>;
}

export function useFlexLayoutContext() {
	const context = useContext(FlexLayoutContext);

	return context;
}
